import { DSButton } from "@components/design-system/molecules";
import mixpanel from "mixpanel-browser";

import { handleSubscribe } from "../../../../../api/Billing";
import { UNLIMITED_PRICE_ID_MONTHLY } from "../../../../../constants";

export default function ClientSummaryFreePlanState({ noteUuid }) {
  const handleUpgrade = () => {
    handleSubscribe({
      priceId: UNLIMITED_PRICE_ID_MONTHLY,
      route: `/edit_note/${noteUuid}`,
    });
    mixpanel.track("Upgrade Plan Clicked", {
      featureName: "Client Summary",
    });
  };
  return (
    <div className="flex flex-col items-center justify-center p-lg space-y-sm bg-secondary rounded-standard">
      <h3 className="text-xl font-semibold text-primary">
        Upgrade to Access Client Summaries
      </h3>
      <p className="text-secondary mb-sm">
        Generate clear, concise summaries for your clients
        automatically from your notes.
      </p>
      <div className="w-full max-w-2xl aspect-video">
        <iframe
          className="w-full h-full rounded-standard"
          src="https://www.youtube.com/embed/OW6zCSwIooI"
          title="Client Summary Demo"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>

      <div className="text-center max-w-2xl mt-md">
        <DSButton
          onClick={handleUpgrade}
          variant="primary"
          dataTestId="upgrade-client-summary-button"
        >
          Get Access to Client Summaries
        </DSButton>
      </div>
    </div>
  );
}
